import type { AxiosResponse } from 'axios';
import { DIRECTORY_SEARCH_ID_TYPES, SEARCHABLE_TYPE } from 'Constants/enums';
import { ContactModelV2 } from 'Models/ContactModelV2';
import type {
  ContactModel,
  ConversationModel,
  IContactDto,
  IConversationModel,
  IPersonModel,
  PersonModel,
  SearchResult,
} from 'Models/index';
import { ISearchableItem } from 'Models/SearchResult';

export type ConversationsMapType = ConversationsMapItem;

export type DirectoryMapType = {
  [prop in DIRECTORY_SEARCH_ID_TYPES]: DirectoryMapItem;
};

export type ConversationsMapItem = {
  query: string;
  data?: SearchResponseData;
  loading?: boolean;
};

export type DirectoryMapItem = {
  query: string;
  data?: SearchResult<SearchableContactModelV2>[];
  loading?: boolean;
  next?: string;
};

export type SearchResponseData = {
  hits: number;
  results: SearchResult<
    PersonModel | ConversationModel | ContactModel | SearchableContactModelV2
  >[];
};

export type DirectorySearchResponseData = {
  hasNext: boolean;
  results: SearchResult<SearchableContactModelV2>[];
};

export type GetPersonContactSearchResponse = AxiosResponse<
  {
    hits: number;
    results: {
      source: IContactDto | IConversationModel | IPersonModel;
      match: string;
      score: number;
    }[];
  },
  any
>;

export class SearchableContactModelV2
  extends ContactModelV2
  implements ISearchableItem
{
  created: string;
  searchableType?: SEARCHABLE_TYPE;

  constructor(contact: ContactModelV2, searchableType?: SEARCHABLE_TYPE) {
    super(contact);

    this.created = contact.createdAt.toString();
    this.searchableType = searchableType;
  }
}
